<template>
  <div class="select-link" :style="{ fontSize: fontSize + 'px', textAlign }">
    <div v-if="!sLink" class="link-box" @click="handleSelectLink()">
      <a class="choice"><i class="el-icon-link"></i>选择链接</a>
    </div>
    <div class="link-box link_box_checked" v-else>
      <i class="el-icon-link"></i>
      <span class="link-title"  style="margin-top:0">{{ sLink.title }}</span>
      <a class="choice ml-10 edit" @click="handleSelectLink()">修改</a>
    </div>
    <LinkModal ref="LinkModal" @handleSubmit="handleSubmit" />
  </div>
</template>

<script>
// import PropTypes from 'ant-design-vue/es/_util/vue-types'
import { LinkModal } from "@/views/apps/weishop/components/Modal";

// 链接选择器组件
export default {
  name: "SLink",
  components: {
    LinkModal,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    // 选中的链接
    value: {},
    // 文字大小
    fontSize: 12,
    // 显示位置
    textAlign: "left", // left居左 right居右
  },
  data() {
    return {
      // 已选择的链接
      sLink: null,
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler(val) {
        this.onUpdate(val);
      },
    },
  },
  created() {},
  methods: {
    // 更新已选择的数据 sLink
    onUpdate(sLink) {
      this.sLink = sLink;
      this.onChange();
    },

    // 打开链接选择器
    handleSelectLink() {
      const { sLink } = this;
      console.log("我在打印点击链接选择器的链接---", sLink);
      this.$refs.LinkModal.handle(sLink);
    },

    // 链接选择器确认回调
    handleSubmit(result) {
      this.onUpdate(result);
    },

    // 触发change事件
    onChange() {
      const { sLink } = this;
      return this.$emit("change", sLink);
    },
  },
};
</script>

<style lang="less" scoped>
.select-link {
  flex: 1;
  min-width: 150px;
  // font-size: 12px;
  .link-box {
    background: #fff;
    border-radius: 2px;
    padding: 6px 6px;
    border: 1px solid #dcdee2;
    display: flex;
    align-items: center;
    i {
      margin-right: 5px;
    }
    &:hover {
      border: 1px solid #006aff;
    }
  }
}
.choice,
.link-title {
  white-space: nowrap;
}
.link_box_checked {
  display: flex;
  align-items: center;
}

.link-title {
  display: block;
  // width: 185px;
  width: 100%;
  // flex: 1;
  white-space: nowrap;
  // overflow: auto;
  overflow: hidden;

}
.edit {
  padding: 0 10px;
}
</style>
